import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Typography, Grid } from "@mui/material";
import stylesCard from "../../styles/Atoms/CardComponent/stylesCard";

function CardComponent({
  sx = {},
  sxCard = {},
  title,
  content,
  count,
  marginTop,
  children,
  fontSize,
  fontSizeCount,
  fontFamily = "Raleway,sans-serif",
  color,
  fontWeight,
  image,
}) {
  return (
    <Card
      sx={{
        ...stylesCard.card,
        ...sxCard,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.45)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ ...sx, position: "relative", zIndex: 1 }}>
        {title && (
          <>
            <Typography
              variant="h5"
              sx={{
                ...stylesCard.title,
                marginTop: marginTop,
                fontSize: fontSize,
                fontFamily: fontFamily,
                color: color,
                fontWeight: fontWeight || stylesCard.title.fontWeight,
              }}
            >
              {title}
            </Typography>
          </>
        )}

        <Typography
          variant="h7"
          sx={{ ...stylesCard.subtitle, fontFamily: fontFamily }}
        >
          {content}
        </Typography>

        <Typography
          variant="h3"
          sx={{
            ...stylesCard.count,
            fontSize: fontSizeCount,
            fontFamily: fontFamily,
            marginTop: marginTop,
          }}
        >
          {count}
        </Typography>

        {children}
      </CardContent>
      {image && (
        <img
          src={image}
          alt=""
          style={{
            position: "absolute",
            bottom: 10,
            right: 10,
            width: "90px",
            height: "90px",
            objectFit: "contain",
            opacity: 0.95,
            pointerEvents: "none",
          }}
        />
      )}
    </Card>
  );
}

export default CardComponent;
